module.exports = __webpack_public_path__ + "media/images/type-8-70db7898f58b6480880662537be9b6f4.png";